import { AxiosRequestConfig } from 'axios'
import {
  RoadmapBaseEvent as Data,
  RoadmapBaseEventCollection as Collection,
} from '@/typings/api/RoadmapBaseEvent'
import { Roadmap } from '@/typings/api/Roadmap'
import { RoadmapDirection } from '@/typings/api/RoadmapDirection'
import { File as CustomFile } from '@/typings/api//File'
import { BaseApiParams } from '@/typings/common'

import { BaseApiAuth } from '@/api/BaseApiAuth'

interface RoadmapBaseEventApiParams extends BaseApiParams {
  roadmap_id: Roadmap['id'];
  direction_id: RoadmapDirection['id'];
  event_id?: Data['id'];
  file_id?: CustomFile['id'];
}

export class RoadmapBaseEventsApi extends BaseApiAuth<Data, Collection, RoadmapBaseEventApiParams> {
  protected readonly endpoint = 'publications/roadmaps/:roadmap_id/directions/:direction_id/base-events';

  public uploadFile(params: RoadmapBaseEventApiParams, file: File, config?: AxiosRequestConfig) {
    const path = ':event_id/files/upload/'
    const [url] = this.getUrl(path, params)
    const data = new FormData()
    data.append('file', file)
    return this.request('POST', url, { data, ...config })
  }

  public deleteFile(params: RoadmapBaseEventApiParams, config?: AxiosRequestConfig) {
    const path = ':event_id/files/:file_id/delete'
    const [url] = this.getUrl(path, params)
    return this.request('POST', url, { ...config })
  }
}
